
import React,  { useEffect, useState, useRef } from "react";
import { connect } from 'react-redux';
import { Grid, List, ListItem, ListItemButton, ListItemText, Select, MenuItem, Checkbox, InputLabel, Popover } from "@mui/material";
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

// custom utils
import { DrawChart } from "../charts/TVChart";
// import { TopBar, LeftBar } from "../bars/StockWatchBars";
import { useWindowDimensions } from "../pages/Utils";

// local json files
import dows from "../data/dow.json";
import nasdaqs from "../data/nasdaq.json";
import sandps from "../data/s&p500.json";
import sandpSectors from "../data/spysectors.json";
import coins from "../data/coins.json";
import russell from "../data/russell_1000.json";
import etfs from "../data/etfs_market_cap.json";
import arkk from "../data/arkk.json";

// const ChartConfig = ({
//     interval = 'D',
//     darkMode = true,
//     handleIntervalChange,
//     handleThemeChange,
// }) => {

//     const intervalList = ['D', 'W', 'M']

//     return (
//             <Grid container sx={{ backgroundColor: 'darkgrey' }}>
//             <Grid item xs={2}></Grid>
//             <Grid item xs={5} sx={{ display: 'flex', alignItems: 'left'}}>
//                 <FormControl variant="filled" size="small" fullWidth>
//                 <InputLabel id="interval">Interval</InputLabel>
//                 <Select
//                     value={interval}
//                     onChange={handleIntervalChange}
//                     MenuProps={{ PaperProps: { sx: { '& .MuiMenuItem-root': { py: 0.5 } } } }}
//                 >
//                     { intervalList.map ( (item, idx) => {
//                         return <MenuItem value={item} key={idx}>{ item }</MenuItem>
//                     })}
//                 </Select>
//                 </FormControl>
//             </Grid>

//             <Grid item xs={5} sx={{ display: 'flex', justifyContent: 'left' }}>
//                 <FormControlLabel
//                 control={
//                     <Checkbox
//                     size="small"
//                     icon={<RadioButtonUncheckedIcon fontSize="small" />}
//                     checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
//                     checked={darkMode}
//                     onChange={handleThemeChange}
//                     />
//                 }
//                 label="Dark"
//                 labelPlacement="start"
//                 />
//             </Grid>
//             </Grid>
//     )
// }



const HomePage = ({ navbarSize, topbarSize, interval, darkMode }) => {

    const dowItems = dows.map(d => d.Ticker);
    const nasdaqItems = nasdaqs.map(d => d.Ticker);
    const sandpItems = sandps.map(d => d.Ticker);
    const russellItems = russell.map(d => d.Ticker);
    const etfItems = etfs.map(d => d.Ticker);
    const arkkItems = arkk.map(d => d.Ticker);
    
    const coinList = coins.slice(0, 500).filter(coin => coin.Stablecoin === false).map(coin => coin.Ticker);
    
    
    const sectorNames = sandpSectors.map(d => d.Ticker+' ('+d.Name+')');
    // console.log(sectorNames);

    const indexList = ['DOW 30 Components', 'NDQ 100 Components', 'S&P 500 Components', 'Russell 1000 Components', 'ARKK Components', 'Cryptocurrency Coins', 'Top 100 ETFs', ...sectorNames];

    // A map to associate list names with their corresponding data arrays.
    // This simplifies the logic in handleWatchlist.
    const listDataMap = {
        'S&P 500 Components': sandpItems,
        'NDQ 100 Components': nasdaqItems,
        'DOW 30 Components': dowItems,
        'Russell 1000 Components': russellItems,
        'Cryptocurrency Coins': coinList,
        'Top 100 ETFs': etfItems,
        'ARKK Components': arkkItems,
    };

    // handle list of index
    const [selectList, setSelectList] = useState('DOW 30 Components');

    const [watchlist, setWatchlist] = useState(dowItems);

    const [symbol, setSymbol] = useState('AAPL');

    const handleWatchlist = (e) => {
        const listSelected = e.target.value;
        let newItems = listDataMap[listSelected];

        if (!newItems && sectorNames.includes(listSelected)) {
            const idx = sectorNames.indexOf(listSelected);
            newItems = sandpSectors[idx]['Comps'].map(v => v.Ticker);
        }

        if (newItems) {
            setWatchlist(newItems);
            setSelectList(listSelected);
            setSymbol(newItems[0] || '');
        }
    }

    // // setting interval
    // const [interval, setInterval] = useState('D');
    // const handleIntervalChange = (e) => {
    //     setInterval(e.target.value);
    //     // console.log(e);
    // }

    // // setting theme
    // const [darkMode, setDarkMode] = useState(true);
    // const handleThemeChange = () => {
    //     setDarkMode(!darkMode);
    //     // console.log(e);
    // }

    // // get interval and theme from local storage, save interval to local storage
    // useEffect(() => {
    //     let localInterval = JSON.parse(localStorage.getItem('user-interval'));
    //     if (localInterval) {
    //         setInterval(localInterval);
    //     }

    //     let localTheme = JSON.parse(localStorage.getItem('dark-theme'));
    //     if (localTheme !== null) {
    //         setDarkMode(localTheme);
    //     }

    // }, []);

    // useEffect(() => {
    //     localStorage.setItem('user-interval', JSON.stringify(interval));
    //     localStorage.setItem('dark-theme', JSON.stringify(darkMode));
    // });

    // Effect to focus the TradingView widget when the list selection changes.
    useEffect(() => {
        const focusTimeout = setTimeout(() => {
            const widgetContainer = document.getElementById('watchlist');
            const iframe = widgetContainer?.querySelector('iframe');
            iframe?.focus({ preventScroll: true });
        }, 500); // 500ms delay.

        return () => clearTimeout(focusTimeout);
    }, [selectList]);

    const [collapsed, setCollapsed] = useState(false);
    const togglePanel = () => {
        setCollapsed(!collapsed);
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const closeTimeout = useRef();

    const handleHoverOpen = (event) => {
        if (collapsed) {
            clearTimeout(closeTimeout.current);
            setAnchorEl(event.currentTarget);
        }
    };
    const handleHoverClose = () => {
        // Set a timeout to close the popover, allowing the cursor to move to it
        closeTimeout.current = setTimeout(() => {
            setAnchorEl(null);
        }, 200);
    };

    const handlePopoverEnter = () => {
        // When the mouse enters the popover, clear the timeout to keep it open
        clearTimeout(closeTimeout.current);
    };

    const handlePopoverLeave = () => {
        // When the mouse leaves the popover, close it immediately
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    // setting chart dimensions *** potential to improve ***
    const topHeight = navbarSize + 10;
    const chartWidth = useWindowDimensions().width;
    const chartHeight = useWindowDimensions().height;

    return (
    <div>
        <Grid container sx={{backgroundColor: 'darkgrey' }}>
        {/* Main chart */}
        <Grid
            item
            sx={{
            flex: 1,                             // ✅ fill remaining space
            height: chartHeight - topHeight,
            }}
        >
            <DrawChart
            width={"100%"}                       // ✅ fills parent Grid
            height={chartHeight - topHeight}
            symbol={symbol}
            watchlist={watchlist}
            interval={interval}
            darkMode={darkMode}
            />
        </Grid>
        {/* Side panel */}
        <Grid
            item
            sx={{
            width: collapsed ? "25px" : { lg: "20%", xl: "10%" },
            height: chartHeight - topHeight,
            overflowY: collapsed ? "hidden" : "auto",
            overflowX: "hidden",
            transition: "all 0.3s ease",
            position: "relative",
            }}
        >
            {/* Collapse/Expand button */}
            <IconButton
            onClick={togglePanel}
            onMouseEnter={handleHoverOpen}   // 👈 show list on hover
            onMouseLeave={handleHoverClose}  // 👈 hide when leaving
            size="large"
            sx={{
                position: "absolute",
                top: 5,
                left: -15,
                zIndex: 10,
                backgroundColor: "white",
                border: "1px solid rgba(0,0,0,0.2)",
                "&:hover": { backgroundColor: "lightgrey" },
            }}
            >
            {collapsed ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
            <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handlePopoverLeave}
            anchorOrigin={{ vertical: "top", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            disableRestoreFocus
            sx={{ pointerEvents: "none" }}   // 👈 prevents flicker
            PaperProps={{
                onMouseEnter: handlePopoverEnter,
                onMouseLeave: handlePopoverLeave,
                // Offset to counteract the IconButton's position and align with the panel
                style: { pointerEvents: "auto", marginLeft: '15px' },
            }}
            >
            <List sx={{ paddingTop: 0 }}>
                {indexList.map((text) => (
                <ListItem
                    key={text}
                    disablePadding
                    sx={{ borderBottom: "1px solid rgba(0, 0, 0, 0.15)" }}
                >
                    <ListItemButton
                    selected={selectList === text}
                    onClick={() => handleWatchlist({ target: { value: text } })}
                    sx={{
                        "&.Mui-selected, &.Mui-selected:hover": {
                        backgroundColor: "lightgrey",
                        },
                    }}
                    >
                    <ListItemText primary={text} />
                    </ListItemButton>
                </ListItem>
                ))}
            </List>
            </Popover>

            {!collapsed && (
            <>
                {/* <ChartConfig
                interval={interval}
                darkMode={darkMode}
                handleIntervalChange={handleIntervalChange}
                handleThemeChange={handleThemeChange}
                /> */}
                <List sx={{ paddingTop: 0 }}>
                {indexList.map((text) => (
                    <ListItem
                    key={text}
                    disablePadding
                    sx={{ borderBottom: "1px solid rgba(0, 0, 0, 0.15)" }}
                    >
                    <ListItemButton
                        selected={selectList === text}
                        onClick={() =>
                        handleWatchlist({ target: { value: text } })
                        }
                        sx={{
                        "&.Mui-selected, &.Mui-selected:hover": {
                            backgroundColor: "lightgrey",
                        },
                        }}
                    >
                        <ListItemText primary={text} />
                    </ListItemButton>
                    </ListItem>
                ))}
                </List>
            </>
            )}
        </Grid>
        </Grid>
    </div>
    );
};

const mapStateToProps = (state) => ({
    navbarSize: state.barSize.navbarSize,
    topbarSize: state.barSize.topbarSize,
    interval: state.settings.interval,
    darkMode: state.settings.darkMode,
});

export default connect( mapStateToProps ) (HomePage);
